import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daf7jn1tto0ceqqnh74g";

const FIELD_CLS =
  "w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-100";

export default function Subscribe() {
  const [formStatus, setFormStatus] = useState("");
  const [formError, setFormError] = useState("");
  const [sending, setSending] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("contact_alt") || "").trim();
    if (honeypot !== "") {
      setFormStatus("success");
      return;
    }
    data.delete("contact_alt");

    setSending(true);
    setFormError("");
    setFormStatus("");
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta ?? {}) as Record<string, unknown>;
      const code = (parsed?.code ?? "") as string;
      const serverMsg = (meta?.message ?? meta?.detail ?? "") as string;
      if (res.ok && code === "OK" && !String(serverMsg).toLowerCase().includes("spam")) {
        setFormStatus("success");
        form.reset();
      } else {
        setFormError(String(serverMsg || "提交失败，请稍后再试"));
      }
    } catch {
      setFormError("网络异常，请稍后再试");
    } finally {
      setSending(false);
    }
  }

  return (
    <section id="subscribe" className="paper-grain w-full py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 overflow-hidden rounded-lg border border-background-300/60 bg-background-50 lg:grid-cols-2">
          <div className="flex flex-col justify-center p-6 md:p-10">
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-mail-send-line text-2xl" />
            </span>
            <h2 className="mt-5 font-heading text-3xl font-black text-foreground-950">订阅档案社，不错过每一个旧瓜</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
              留下邮箱即可每周收到编辑部整理好的 <strong className="font-semibold text-foreground-900">吃瓜八卦时间线</strong>
              与 <strong className="font-semibold text-foreground-900">翻旧账合集</strong>。也欢迎通过表单提交你的旧料线索。
            </p>
            <ul className="mt-5 space-y-2 text-sm text-foreground-700">
              {[
                "每周精选：旧料翻旧账与陈年往事档案",
                "热点复盘：被重新提起的老话题第一时间解读",
                "读者投稿：你的吃瓜八卦考古线索优先跟进",
              ].map((t) => (
                <li key={t} className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-600" />
                  {t}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-100 p-6 md:p-10">
            <h3 className="font-heading text-xl font-bold text-foreground-950">订阅 / 提交线索</h3>
            {formStatus === "success" && (
              <p className="mt-4 flex items-center gap-2 rounded-md bg-secondary-100 px-4 py-3 text-sm font-medium text-secondary-900">
                <i className="ri-checkbox-circle-line" />
                已收到你的信息，欢迎常来吃瓜考古！
              </p>
            )}
            {formError && (
              <p className="mt-4 flex items-center gap-2 rounded-md bg-accent-100 px-4 py-3 text-sm font-medium text-accent-800">
                <i className="ri-error-warning-line" />
                {formError}
              </p>
            )}
            <form
              data-readdy-form="旧瓜档案馆资讯订阅与反馈表单"
              onSubmit={handleSubmit}
              className="mt-6 space-y-4"
            >
              <input className="footer-field-hidden" type="text" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <div>
                <label htmlFor="s-name" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  怎么称呼你
                </label>
                <input id="s-name" name="name" type="text" required className={FIELD_CLS} placeholder="例如：爱吃瓜的小编" />
              </div>
              <div>
                <label htmlFor="s-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  邮箱地址
                </label>
                <input id="s-email" name="email" type="email" required className={FIELD_CLS} placeholder="you@example.com" />
              </div>
              <div>
                <label htmlFor="s-msg" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  想说的话 / 旧料线索（选填）
                </label>
                <textarea
                  id="s-msg"
                  name="message"
                  maxLength={500}
                  rows={4}
                  className={FIELD_CLS}
                  placeholder="欢迎分享你记得的吃瓜八卦旧料线索……"
                />
              </div>
              <button
                type="submit"
                disabled={sending}
                className="w-full whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
              >
                {sending ? "提交中…" : "订阅并提交"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}